import Component from '@glimmer/component';

import date from 'rise-ui/helpers/date.js';
import dateParse from 'rise-ui/helpers/date-parse.js';
import isMinMaxDate from 'rise-ui/helpers/is-min-max-date.js';
import or from 'rise-ui/helpers/or.js';
import string from 'rise-ui/helpers/string.js';
import utcOffset from 'rise-ui/helpers/utc-offset.js';

export default class DateRangeDisplayComponent extends Component {
  <template>
    {{#let
      (or @dateFormat "short")
      (dateParse @fromDate)
      (dateParse @toDate)
      as | dateFormat fromDate toDate |
    ~}}
    <span class="c-date-range-display">
      <span class="c-date-range-display__from">
        <span class="c-date-range-display__from-label">From:</span>
        {{#if (isMinMaxDate @fromDate)}}
          <span class="c-date-range-display__from-no-date"
          >{{string "first-datum"}}</span>
        {{else}}
          {{#if fromDate}}
            <span class="c-date-range-display__from-date"
            >{{date (utcOffset fromDate) dateFormat}}</span>
          {{else}}
            <span
              class="c-date-range-display__from-date c-date-range-display__from-date--empty"
            ></span>
          {{/if}}
        {{/if}}
      </span>
      <span class="c-date-range-display__to">
        <span class="c-date-range-display__to-label">To:</span>
        {{#if (isMinMaxDate @toDate)}}
          <span class="c-date-range-display__to-no-date"
          >{{string "last-datum"}}</span>
        {{else}}
          {{#if toDate}}
            <span class="c-date-range-display__to-date"
            >{{date (utcOffset toDate) dateFormat}}</span>
          {{else}}
            <span
              class="c-date-range-display__to-date c-date-range-display__to-date--empty"
            ></span>
          {{/if}}
        {{/if}}
      </span>
    </span>
    {{~/let~}}
  </template>
}
